import { FontAwesome } from "@expo/vector-icons";
import { Text } from "@ui-kitten/components";
import { useAccount } from "hooks/useAccount";
import i18n from "plugins/localization";
import React from "react";
import { View } from "react-native";
import { getCreditCardIcon, walletTypeLabel } from "utils/billingUtils";
import { LINE, PANEL } from "../helpers";

// The signed-in shopper's payment method on file, shown on the payment
// step so they can see exactly which card the purchase will charge.
// Renders nothing when the account has no card saved.
const CardOnFileV3 = () => {
  const { account } = useAccount();
  if (!account?.billingLast4) return null;

  const walletLabel = walletTypeLabel(account.billingWalletType);

  return (
    <View
      testID="v3-card-on-file"
      className="flex-row items-center border rounded-xl px-3 py-2 mb-2"
      style={{ borderColor: LINE, backgroundColor: PANEL }}
    >
      <FontAwesome
        name={getCreditCardIcon(account.billingBrand)}
        size={22}
        color="#251f20"
      />
      <View style={{ marginLeft: 10 }}>
        <Text category="s2">
          {account.billingBrand} •••• {account.billingLast4}
          {walletLabel ? ` (${walletLabel})` : ""}
        </Text>
        {account.billingExpiration ? (
          <Text category="c1" appearance="hint">
            {i18n.t("components.CardOnFileV3.expires", {
              date: account.billingExpiration,
            })}
          </Text>
        ) : null}
      </View>
    </View>
  );
};

export default CardOnFileV3;
